export const LeakageMock = {
  totalFlow: 34.775447116938395,
  totalKw: 322.11210653447614,
  leakRateFlow: 23.41781112841569,
  leakRatePercent: 67.34007200444984,
  kwLeakRate: 216.9105244753664,
  lastMeasureDate: '2023-12-25T00:00:00.000Z',
  previousLeakRateFlow: 24.8902732549908,
  leakageWasted: {
    yearToDate: {
      energyKwh: 594853,
      savingValue: 50562,
      savingCurrency: 'USD',
    },
    lifetime: {
      energyKwh: 795553,
      savingValue: 67622,
      savingCurrency: 'USD',
    },
  },
  actionTaken: {
    yearToDate: {
      savingCo2: 0,
      savingValue: 51020,
      savingCurrency: 'USD',
    },
    lifetime: {
      savingCo2: 28.120096878377733,
      savingValue: 60223,
      savingCurrency: 'USD',
    },
  },
};
